<app-modal-shell
  [title]="'ADDRESS_DATA.TITLE'"
  [cancelLabel]="'ADDRESS_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'ADDRESS_DATA.BUTTONS.OK'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    <app-address-details-form [initialData]="addressDetails" testIdPrefix="address-data"></app-address-details-form>
  </div>

</app-modal-shell>
